import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Loft } from '../../api/models';

export type TABLE_TYPE = Table<Loft>;

export const TABLE = 'loft';
const SCHEMA = '&loftId, sortId';

class LoftDatabase implements DataRepository<Loft> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<Loft | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Loft, key: Key): Promise<Loft> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: Loft[]): Promise<Loft[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Loft[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const LoftDB = new LoftDatabase(db);
